/* eslint-disable import-alias/import-alias*/

import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { getCookie } from '@utils/cookies';
import store from '@state/store';
import { selectProduct } from '@components/ProductDetail/state/productDetailSlice.js';
import { selectFeatureEnabled } from '@state/featureToggleSlice';
import { selectUser } from '@state/userSlice';
import { useUpsertItemMutation, QUOTES_KEY_COOKIE } from './quotesApi';
import { RequestAQuoteButton } from './RequestAQuoteButton';


export const ConnectedRequestAQuoteButton: React.FC = () => {
  const [upsertItem] = useUpsertItemMutation();
  const product = useSelector(state => selectProduct(state));
  const requestAQuoteFeature = useSelector(state => selectFeatureEnabled('request_a_quote')(state));
  const currentUser = useSelector(state => selectUser(state));

  const handleOpenModal = async () => {
    await upsertItem({
      variantCode: product?.variant?.code || '',
      unitOfMeasureCode: product?.unitOfMeasureCode || '',
      quantity: 1,
      cartKey: getCookie(QUOTES_KEY_COOKIE)
    });
  };
  // Offers do not work for logged in users
  return (requestAQuoteFeature && !currentUser?.isLoggedIn ? (
    <RequestAQuoteButton onClick={handleOpenModal} />
  ) : null);
};

export const ProvideRequestAQuoteButton = (props: any) => {

  return (
    <Provider store={store}>
      <ConnectedRequestAQuoteButton {...props} />
    </Provider>
  );
};
